export const CONFIG_VARS = Object.freeze({
  currentEnvironment: "preprod",
  // currentEnvironment: "prod",

  deeplinkBaseUrl: {
    preprod: "https://preprod.inmobiusinfinitylearn.com/",
    staging: "https://preprod.inmobiusinfinitylearn.com/",
    prod: "https://inmobiusinfinitylearn.com/deeplink/exampage",
  },

  baseUrl: {
    // 1: "https://uds.devinfinitylearn.in/api", // gcp
    1: "https://inmobiusjob.devinfinitylearn.in/api", // pre-prod URL
    // 1: "https://inmobiusstaging.devinfinitylearn.in/api", // staging URL
    // 1: "https://inmobiusjob.infinitylearn.com/api", // prod URL
    //1: "https://poc.inmobiusinfinitylearn.com/api" //prod replica
  },
  gatewayBaseUrl: {
    // 1: "https://testgatewaygcp.devinfinitylearn.in/api", // gcp
    //1: "https://gatewaystaging.devinfinitylearn.in/api", // stating URL
    // 1: "https://gatewayapilearn.infinitylearn.com/api", // prod URL
    1: "https://gatewayapi.devinfinitylearn.in/api", //preprod
    //1: "https://pocgateway.inmobiusinfinitylearn.com/api", //prodreplica
  },
  inmobiusJobBaseUrl: {
    // 1: "https://uds.devinfinitylearn.in/api", //gcp
    1: "https://inmobiusjob.devinfinitylearn.in/api", // preprod
    // 1: "https://inmobiusjob.infinitylearn.com/api", // prod
  },
  gatewayApiSecretKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // preprod
  // gatewayApiSecretKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod

  apiKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", //preprod
  // apiKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",
  roleMappings: {
    1: {
      // preprod
      5: "Super Admin",
      47: "MIS Team Admin",
      48: "General Manager",
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
      52: "School Admin",
    },
    // 1: {
    //   // staging
    //   5: "Super Admin",
    //   47: "MIS Team Admin",
    //   48: "General Manager",
    //   49: "Senior Manager",
    //   50: "Manager",
    //   51: "Execution Rep",
    //   52: "School Admin",
    // },
    // 1: {
    //   // prod
    //   5: "Super Admin",
    //   45: "MIS Team Admin",
    //   46: "General Manager",
    //   47: "Senior Manager",
    //   48: "Manager",
    //   49: "Execution Rep",
    //   50: "School Admin",
    // },
  },
  hierarchy_role_ids: {
    1: {
      // preprod
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
    },
    // 1: {
    //   // staging
    //   49: "Senior Manager",
    //   50: "Manager",
    //   51: "Execution Rep",
    // },
    // 1: {
    //   // prod
    //   47: "Senior Manager",
    //   48: "Manager",
    //   49: "Execution Rep",
    // },
  },
});
